import { BarChart, Bar, Tooltip, ResponsiveContainer } from "recharts"

export default function GradientBarChart({ data, width = "100%", height = 300, gradientFrom, gradientTo, uniqueId }) {
  const gradientId = `gradient-${uniqueId}`

  return (
    <ResponsiveContainer width={width} height={height}>
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 0,
          left: 0,
          bottom: 0,
        }}
      >
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={gradientFrom} />
            <stop offset="100%" stopColor={gradientTo} />
          </linearGradient>
        </defs>
        {/* <XAxis dataKey="name" /> */}
        {/* <YAxis /> */}
        {/* <Tooltip /> */}
        <Bar
          dataKey="uv"
          fill={`url(#${gradientId})`}
          radius={[100, 100, 100, 100]}
          background={{ fill: "#EFF2FB", radius: [50, 50, 50, 50] }}
          // label={{ position: 'top', fill: '#000', fontSize: 12 }}
        />
      </BarChart>
    </ResponsiveContainer>
  )
}
